((window, document) => {
  // Pre-populate the comments field on the enquiry form
  function checkForMakeModel(url) {
    const pattern = /^\/[a-z0-9-]+\/[a-z0-9-]+\/\d+\/[a-z0-9.-]+\/enquire\/$/i;
    return pattern.test(url);
  }

  function toTitleCase(phrase) {
    return phrase
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  const { pathname } = window.location;
  const isSimpleEnquirePage = /^\/(enquire|contact)(\/|$)/.test(pathname);
  const isMakeEnquire = /^\/[a-z0-9-]+-vans\/[a-z0-9-]+\/enquire\/?$/.test(pathname);
  const isMakeModelEnquire = checkForMakeModel(pathname);
  const isEnquirePage = isSimpleEnquirePage || isMakeEnquire || isMakeModelEnquire;
  const particularVanLine = 'Are you looking for any particular van? (Make, Model or size)';

  if (isEnquirePage) {
    const commentsField = document.getElementById('Q46');
    const urlVars = Object.fromEntries(new URLSearchParams(window.location.search));
    const financeType = urlVars.finType || '';
    let financeLine = '';
    const financeMessages = {
      buy: 'I am interested in buying this van.',
      lease: 'I am interested in leasing this van.',
    };
    financeLine = financeMessages[financeType] || '';
    let makeModelLine = '';
    if (isMakeEnquire) {
      const array = pathname.split('/');
      const model = toTitleCase(array[2].replaceAll('-', ' '));
      makeModelLine = `I would like to enquire about a ${model} van`;
    }
    if (commentsField) {
      commentsField.value = [
        ...(isMakeEnquire ? [makeModelLine, ''] : []),
        'To help us find you the very best deal on your new van please provide the following information (optional)',
        '',
        ...(isSimpleEnquirePage ? [particularVanLine, ''] : []),
        'How many miles do you expect to drive each year?',
        '',
        'How many years would you like to keep the van?',
        '',
        'How much deposit would you like to put down up front?',
        '',
        'Would you like a fixed monthly quote to cover servicing, maintenance, and tyres?',
        '',
        'Is there anything else we should know?',
        '',
        ...(financeType ? [financeLine, ''] : []),
      ].join('\r\n');
    }
    const buyNowButtons = document.querySelectorAll('.js-call-now');
    buyNowButtons.forEach((button) => {
      button.classList.remove('abtest_call_buy', 'abtest_call_lease');
      const dataClass = `abtest_call_${financeType || 'default'}`;
      button.classList.add(dataClass);
    });
  }
})(window, document);
